/**
 * Add to Cart AJAX
 */
export default class AddToCartAjax {
    constructor() {
        this.init();
    }

    init() {
        const forms = document.querySelectorAll('form.cart');

        forms.forEach(form => {
            form.addEventListener('submit', (e) => this.handleSubmit(e));
        });
    }

    handleSubmit(e) {
        const form = e.target;
        const button = form.querySelector('button[type="submit"]');

        // Check if button is disabled (variation not selected)
        if (button.disabled) {
            return;
        }

        e.preventDefault();

        const formData = new FormData(form);

        // Store original button text
        const originalText = button.textContent;

        // Add loading state
        button.classList.add('loading');
        button.disabled = true;
        button.textContent = 'Dodajem...';

        // Get product ID and quantity
        const productId = formData.get('product_id') || formData.get('add-to-cart') || form.getAttribute('product_id');
        const quantity = formData.get('quantity') || 1;
        const variationId = formData.get('variation_id');

        // Build request body for Store API
        const requestBody = {
            id: parseInt(variationId || productId),
            quantity: parseInt(quantity)
        };

        // Add variation attributes if this is a variable product
        if (variationId) {
            const variation = [];
            for (const [key, value] of formData.entries()) {
                if (key.startsWith('attribute_')) {
                    variation.push({
                        attribute: key,
                        value: value
                    });
                }
            }
            if (variation.length > 0) {
                requestBody.variation = variation;
            }
        }

        // Use WooCommerce Store API
        const apiUrl = `${window.location.origin}/wp-json/wc/store/v1/cart/add-item`;

        fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Nonce': this.getNonce()
            },
            body: JSON.stringify(requestBody)
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Failed to add to cart');
            }
            return response.json();
        })
        .then((data) => {
            // Cart data is returned directly, update fragments
            this.updateCartFromStoreAPI(data);

            // Show success notice
            this.showNotice('Proizvod je dodan u košaricu');

            // Reset button state - remove disabled class every 500ms for 5 seconds
            this.resetButtonState(button, originalText);
        })
        .catch((error) => {
            console.error('Add to cart error:', error);
            this.resetButtonState(button, originalText);
        });
    }

    getNonce() {
        // Try to get nonce from pumpkin object
        if (window.pumpkin && window.pumpkin.wc_store_api_nonce) {
            return window.pumpkin.wc_store_api_nonce;
        }

        // Try to get from window
        if (window.wc_store_api_nonce) {
            return window.wc_store_api_nonce;
        }

        // Try to get from meta tag
        const nonceMeta = document.querySelector('meta[name="wc-store-api-nonce"]');
        if (nonceMeta) {
            return nonceMeta.content;
        }

        // Fallback to empty string (will use cart token if available)
        return '';
    }

    updateCartFromStoreAPI(cartData) {
        // Update cart count from Store API response
        if (cartData.items_count !== undefined) {
            const cartContents = document.querySelector('.cart-contents');
            if (cartContents) {
                const countElement = cartContents.querySelector('.count');
                const iconBasket = cartContents.querySelector('.icon-basket');

                if (countElement) {
                    countElement.textContent = cartData.items_count;
                }

                if (iconBasket) {
                    if (cartData.items_count > 0) {
                        iconBasket.classList.add('has-items');
                    } else {
                        iconBasket.classList.remove('has-items');
                    }
                }
            }
        }

        // Trigger event for other scripts that might need to update
        document.body.dispatchEvent(new CustomEvent('wc-blocks_added_to_cart', {
            detail: { cartData }
        }));
    }

    resetButtonState(button, originalText) {
        button.classList.remove('loading');
        button.classList.add('added');
        button.disabled = false;

        // Restore original button text
        if (originalText) {
            button.textContent = originalText;
        }

        // Remove 'disabled' class every 500ms for 5 seconds
        let attempts = 0;
        const maxAttempts = 10; // 10 * 500ms = 5 seconds

        const interval = setInterval(() => {
            attempts++;
            button.classList.remove('disabled');
            button.disabled = false;

            if (attempts >= maxAttempts) {
                clearInterval(interval);
            }
        }, 500);

        // Reset 'added' class after 2 seconds
        setTimeout(() => {
            button.classList.remove('added');
        }, 2000);
    }



    showNotice(message) {
        const notice = document.createElement('div');
        notice.className = 'woocommerce-message woocommerce-info alert-global';
        notice.textContent = message;

        document.body.appendChild(notice);

        setTimeout(() => {
            notice.style.animation = 'slideOut 0.3s ease-out';
            setTimeout(() => {
                notice.remove();
            }, 300);
        }, 2000);
    }
}
